import { createRouter, createWebHashHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import LoginPage from "@/views/LoginPage";
import ReportPage from "@/views/ReportPage";
import ReportChart from "@/views/ReportChart";
import HorekaReport from "@/views/HorekaReport";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: LoginPage,
  },
  {
    path: "/report/:type",
    name: "Report",
    component: ReportPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/ReportChart",
    name: "ReportChart",
    component: ReportChart,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/HorekaReport",
    name: "HorekaReport",
    component: HorekaReport,
    meta: {
      requiresAuth: true,
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    // @todo use vuex store
    if (localStorage.getItem("token") === null) {
      if (from.name === "ShoppingCart") {
        next({
          path: "/login",
          query: { redirect: from.path },
        });
      } else {
        next({ path: "/login" });
      }
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
